<template>
    <div class="page-talents-introduce">
        <div class="introduce-top-wrap">
          <div class="introduce-main-box">
            <div class="top-tit">
              <h2>简历动态同步</h2>
              <p class="txt1">告别陈旧简历，盘活企业自有人才库</p>
              <a href="javascript://" @click="unloginBuyServicePop = true">点击购买</a>
            </div>
	          <div class="top-mac"></div>
          </div>

        </div>

        <div class="introduce-contrast">
          <div class="introduce-main-box">
            <p class="en">RESUME LIBRARY WEAKPOINTS</p>
            <p class="p1">简历库痛点分析</p>
            <div class="content-box clearfix">
              <img src="../../assets/introduce/update/pic1.png" class="fl"/>
              <div class="info">
                <h3>A. 简历陈旧不更新</h3>
                <div class="list clearfix">
                  <img src="../../assets/introduce/update/icon1.png" class="fl"/>
                  <div class="message">
                    <p class="sty1">联系方式改变</p>
                    <p class="sty2">HR拨打求职者电话，停机、空号、不是本人；</p>
                  </div>
                </div>
                <div class="list clearfix">
                  <img src="../../assets/introduce/update/icon2.png" class="fl"/>
                  <div class="message">
                    <p class="sty1">求职意愿改变</p>
                    <p class="sty2">求职意愿改变：HR与求职者沟通，对方找不到工作、已经找到工作；</p>
                  </div>
                </div>
                <div class="list clearfix">
                  <img src="../../assets/introduce/update/icon3.png" class="fl"/>
                  <div class="message">
                    <p class="sty1">简历内容改变</p>
                    <p class="sty2">求职者与HR推荐的公司、职位、薪酬、工作地点 等不感兴趣。</p>
                  </div>
                </div>
              </div>
            </div>
             <div class="content-box clearfix">
              <img src="../../assets/introduce/update/pic2.png" class="fl"/>
              <div class="info">
                <h3 class="mt70">B. 简历不完整</h3>
                <div class="list clearfix">
                  <img src="../../assets/introduce/update/icon4.png" class="fl"/>
                  <div class="message">
                    <p class="sty1">无法推荐合适的职位</p>
                    <p class="sty2">缺少工作经历、教育经历、期望薪酬、工作地点等；</p>
                  </div>
                </div>
                <div class="list clearfix">
                  <img src="../../assets/introduce/update/icon5.png" class="fl"/>
                  <div class="message">
                    <p class="sty1">导致沟通障碍与对立情绪</p>
                    <p class="sty2">HR与求职者联系时，不了解对方情况。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="introduce-after-service">
          <div class=" introduce-main-box">
            <p class="en">AFTER TRIAL</p>
            <p class="p1">使用简历库实时更新服务之后</p>
            <div class="img-content clearfix">
              <img class="fl" src="../../assets/introduce/update/chat1.png"/>
              <img class="fr" src="../../assets/introduce/update/chat2.png"/>
            </div>
          </div>
        </div>
        <div class="introduce-buy">
          <p class="p1">申请购买可以点击下方链接</p>
          <p class="p2">客户经理会第一时间与您取得联系</p>
          <a href="javascript://" @click="unloginBuyServicePop = true">购买简历库更新</a>
        </div>
        <unlogin-buy-service-success :service-user="serviceUser" v-if="unloginBuyServiceSuccessPop" v-model="unloginBuyServiceSuccessPop"></unlogin-buy-service-success>
        <unlogin-buy-service tit="购买简历库更新" desc="企业人才库服务" code="talentPool" v-if="unloginBuyServicePop" @openServiceSuccess="openServiceSuccess" v-model="unloginBuyServicePop"></unlogin-buy-service>
    </div>
</template>
<script>
import unloginBuyService from "@/components/unloginBuyService";
import unloginBuyServiceSuccess from "@/components/unloginBuyServiceSuccess";
import DB from "@/common/db";
export default {
  name: "update-introduce",
  data() {
    return {
      unloginBuyServicePop: false,
      unloginBuyServiceSuccessPop: false,
      serviceUser: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      DB.request({
        url: DB.prefix + "auth/v2/link",
        type: "get",
        success: res => {
          if (res.data && res.data.isLogin) {
            window.location.href = "/updateTalents.html#/introduce";
          }
        },
        complete: () => {}
      });
    });
  },
  methods: {
    openServiceSuccess(serviceUser) {
      this.serviceUser = serviceUser;
      this.unloginBuyServiceSuccessPop = true;
    }
  },
  components: {
    unloginBuyService,
    unloginBuyServiceSuccess
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-talents-introduce {
  width: 100%;
  background: #fff url("../../assets/introduce/bg.jpg") no-repeat 0 -330px;
  background-size: 100%;
  height: 500px;
  .introduce-main-box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .introduce-top-wrap {
    height: 500px;
    background: #18c1d0;
    background: rgba(24, 193, 208, 0.8);
    background-size: 100%;
    filter: Alpha(opacity=.8);
    *zoom: 1;
    color: #fff;
    .top-tit {
      padding-top: 156px;
      color: #fff;
      width: 100%;
      h2 {
        font-size: 48px;
        line-height: 68px;
      }
      p {
        font-size: 24px;
        line-height: 40px;
      }
      .txt2 {
        font-size: 16px;
        strong {
          margin-left: 5px;
        }
      }
      a {
        border-radius: 42px;
        font-size: 18px;
        line-height: 45px;
        display: inline-block;
        height: 45px;
        color: #1abeb9;
        width: 188px;
        margin-top: 30px;
        background: #fff;
        text-align: center;
      }
    }
    .top-mac {
      position: absolute;
      width: 690px;
      height: 468px;
      background: url("../../assets/introduce/update/mac3.png") no-repeat left 0;
      background-size: 100%;
      right: 0;
      top: 170px;
    }
  }
  .introduce-after-service {
    padding: 70px 0;
    background: url("../../assets/introduce/roadmap-bg.jpg");
    background-size: contain;
    .en {
      font-size: 14px;
      font-weight: bold;
      color: #2d8cf0;
      text-align: center;
    }
    .p1 {
      font-size: 36px;
      color: #393a41;
      text-align: center;
    }
    .introduce-main-box {
      .img-content {
        margin: 80px auto 80px;
        width: 770px;
      }
    }
  }
  .introduce-contrast {
    background-color: #fff;
    padding: 150px 0 30px;
    .en {
      font-size: 14px;
      font-weight: bold;
      color: #2d8cf0;
      text-align: center;
    }
    .p1 {
      font-size: 36px;
      color: #393a41;
      text-align: center;
    }
    .introduce-main-box {
      .content-box {
        width: 980px;
        padding: 50px 0 55px;
        margin: 0 auto;
        .info {
          float: left;
          margin-left: 110px;
          h3 {
            font-size: 24px;
            color: #393a41;
            font-weight: bold;
            margin-top: 15px;
          }
          .mt70 {
            margin-top: 70px;
          }
          .list {
            margin-top: 40px;
            img {
              margin-top: 10px;
            }
            .message {
              float: left;
              margin-left: 20px;
              .sty1 {
                font-weight: bold;
                font-size: 20px;
                color: #2d8cf0;
              }
              .sty2 {
                font-size: 16px;
                color: #393a41;
              }
            }
          }
        }
      }
    }
  }

  .introduce-buy {
    width: 100%;
    height: 250px;
    background: #fff url("../../assets/introduce/footer.jpg") no-repeat center
      center;
    text-align: center;
    color: #fff;
    padding-top: 45px;
    .p1 {
      font-size: 36px;
      line-height: 50px;
    }
    .p2 {
      font-size: 20px;
      line-height: 28px;
      margin-top: 4px;
    }
    a {
      border-radius: 42px;
      font-size: 18px;
      line-height: 45px;
      display: inline-block;
      height: 45px;
      color: #2d8cf0;
      width: 188px;
      margin-top: 30px;
      background: #fff;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/unloginIntroduce/updateIntroduce.vue